module.exports = __webpack_public_path__ + "static/media/breakfast.247690c7.svg";